module.exports = __webpack_public_path__ + "img/index2.7a90d1a5.png";